import React from 'react';
import './Blog.css'




const Blog = () => {

    return (
        <div>
            <h1>Student Satisfaction</h1>
            <div className='bloging'>
                {/* bloging */}
                <div className='border border-warning m-3 '>

                    <p>It remains reliable, fair and accurate, because it uses standard IELTS marking procedures and official IELTS examiners. You will get your scores within seven days – both an indicative score for each section and an overall band score.</p>

                </div>
                <div className='border border-warning m-3 '>

                    <p>One of the most best institude in Dhaka City.</p>
                </div>
            </div>
        </div>
    );
};

export default Blog;